<template>
  <div class="out">
    <banner />
    <div class="stickybar">
      <a :style="nowindex === 1 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(1)">产品简介</a>
      <a :style="nowindex === 2 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(2)">功能介绍</a>
      <a :style="nowindex === 3 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(3)">产品优点</a>
      <a :style="nowindex === 4 ? {'border-bottom': '3px solid #0086f1'} : {'border': 'none'}" @click="jump(4)">客户成功案例</a>
    </div>
    <div
      ref="parti"
      class="review"
      style="background-color: rgba(255, 255, 255); margin-left: 0; margin-right: 0"
    >
      <div class="title">
        <div id="partone" class="top-text">
          <h3>智慧资管简介</h3>
          <p class="big_des">
            智慧资管是一款专业的云端高效资产管理系统，具有免安装、免维护、操作简单等特点。有效实现业务、资产一体化，减少资产固话工作量，提升工作效率。
          </p>
          <!-- <img src="@/assets/solution3-1.97f0170.png"> -->
          <ul class="system-content wow bounceInLeft" data-wow-duration="1s" data-wow-delay="0s">
            <li>
              <img class="setup" src="@/assets/system_1.png">
              <p>免安装</p>
            </li>
            <li>
              <img class="maintain" src="@/assets/system_2.png">
              <p>免维护</p>
            </li>
            <li>
              <img class="handle" src="@/assets/system_3.png">
              <p>操作简单</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div id="parttwo" ref="partii" class="function-wrap wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="function-box">
        <p class="h1">智慧资管功能介绍</p>
        <ul class="function-content">
          <li>
            <i class="function-1"/>
            <p class="title1">资产立项</p>
            <p class="detail">
              按需生成多类型资产立项<br >
            </p>
          </li>
          <li>
            <i class="function-2"/>
            <p class="title1">项目发包</p>
            <p class="detail">
              统一多种立项，生成项目包<br >
              进行统一审批与管理
            </p>
          </li>
          <li>
            <i class="function-3"/>
            <p class="title1">合同管理</p>
            <p class="detail">修改信息、导入合同、终止合同、提交申请</p>
          </li>
          <li>
            <i class="function-4"/>
            <p class="title1">租金收缴</p>
            <p class="detail">多种类资产催收，逾期提醒</p>
          </li>
          <li>
            <i class="function-5"/>
            <p class="title1">固定资产</p>
            <p class="detail">多种类资产信息管理</p>
          </li>
          <li>
            <i class="function-6"/>
            <p class="title1">更多功能</p>
            <p class="detail">敬请期待......</p>
          </li>
        </ul>
      </div>
    </div>
    <div id="partthree" ref="partiii" class="gc_ceng gc_ceng_four wow bounceInUp" data-wow-duration="1s" data-wow-delay="0s">
      <div class="ceng_thin">
        <div class="ceng_title">智慧资管的优势</div>
        <div class="ceng_decro">核心优势 管理无忧</div>
        <div class="ceng_box">
          <div>
            <div>
              <img alt="" src="@/assets/qq1.png" width="150" lazy="loaded">
            </div>
            <p>一键导出资产信息<br>一键导入现有合同<br>项目包统一管理<br>虚拟合同便于操作</p>
          </div>
          <div>
            <div style="box-shadow:0 0 0 0; background: transparent">
              <img alt="" src="@/assets/qq2.png" width="200px" height="200px" margin-left="100px" lazy="loaded">
            </div>
            <p>报表数据云端储存<br><br>云端项目，随时登录<br></p>
          </div>
          <div>
            <div>
              <img alt="" src="@/assets/qq3.png" width="140" lazy="loaded">
            </div>
            <p>收缴逾期人性化提醒<br>资产地图一览无余<br>资产项目在线查看</p>
          </div>
        </div>
      </div>
    </div>
    <div id="partfour" class="customer_success">
      <p>客户成功案例</p>
      <div class="customer_success-box">
        <img src="@/assets/page_sanzi.png" alt="">
      </div>
      <h4>苏州市吴中区农业农村局：智慧资产系统化管理</h4>
      <p class="wuzhong_desc">苏州吴中区农业农村局联合睿泽构建“资产管理”数字化运营平台，对镇级，村级资产数据进行统一管控、监管管理、流程管理提升运营效率，释放管理价值。    </p>

    </div>
    <CircleBtn @back="back" />

  </div>
</template>

<script>
import myCarousel from '@/components/carousel'
import sidemenu from '@/components/sidemenu.vue'
import Introducecard from '@/components/introducecard.vue'
import Banner from '@/views/products/components/Banner'
import CircleBtn from '@/components/CircleBtn.vue'

export default {
  name: 'AssetManagement',
  components: { myCarousel, sidemenu, Introducecard, Banner, CircleBtn },
  data() {
    return {
      nowindex: 1
    }
  },
  methods: {
    jump: function(x) {
      this.nowindex = x
      if (x === 1) {
        x = '#partone'
      }
      if (x === 2) {
        x = '#parttwo'
      }
      if (x === 3) {
        x = '#partthree'
      }
      if (x === 4) {
        x = '#partfour'
      }
      document.querySelector(x).scrollIntoView(true)
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
}
h3 {
  color: #256cff; font-weight:bolder;
  margin-bottom: 25px;
}
.customer_success {
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding-top: 85px;
  padding-bottom: 90px;
}
.customer_success p:nth-child(1) {
    margin: auto;
    width: auto;
    height: auto;
    font-size: 32px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(6,24,40,1);
}
h4 {
  margin: 20px 0 10px
}
.customer_success .wuzhong_desc {
    margin: auto;
    margin-top: 20px;
    width: 1000px;
    height: auto;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 300;
    color: rgba(13,10,38,1);
    line-height: 24px;
    text-align: center;
}
.customer_success-box {
  max-width: 1200px;
  margin: 50px auto 0 auto;

}
.customer_success-box  img {
  width: 90%;
  margin: 0 auto;
  border: solid
}
.big_des {
  text-align: center;
  width: 70%;
  margin: 0 auto;
  margin-bottom: 5%;
}
#partfour {
  background: rgba(234,239,243,1);
}

.title {
  /* width: 1200px; */
  text-align: center;
  margin: 0 auto;
}

.top-text {
  padding: 3.5% 0 4% 0;
  /* max-width: 1200px; */
  /* margin: 0 auto; */
}

.stickybar {
  position: sticky;
  top: 0;
  display: flex;
  background-color: white;
  z-index: 99;
  padding: 0% 7% 0% 13%;
}
.stickybar a {
  padding: 2% 4%;
  cursor: pointer;
  text-decoration: none;
  color: black;
}
li {
  list-style-type: none;
}
.function-wrap {
  width: 100%;
  /* height: 890px; */
  position: relative;
  /* background: url(../assets/function_bg.jpg) 50% 50% no-repeat; */
  background-size: cover;
  /* -ms-behavior: url(css/backgroundsize.min.htc);
  behavior: url(css/backgroundsize.min.htc); */
}
.function-box {
  /* width: 1210px; */
  position: relative;
  overflow: hidden;
  margin: 0 auto;
}
.function-box > p.h1 {
  font-size: 32px;
  color: #333;
  text-align: center;
  line-height: 1;
  padding: 70px 0 130px;
}
.function-content {
  width: 100%;
  position: relative;
  display: flex !important;
  flex-direction: row !important;
  flex-wrap: wrap !important;
  justify-content: space-between !important;
}
.function-content li {
  position: relative;
  width: 33%;
  /* width: 350px;
  height: 250px;
  float: left;
  margin-left: 40px; */
  background: #fff;
  border-radius: 5px;
  margin-bottom: 70px;
}
.function-content li:first-child,
.function-content li:first-child + li + li + li {
  margin-left: 0px;
}
.function-content li:first-child + li + li + li + li + li + li {
  margin-left: 0px;
}
.function-content li p.title1 {
  text-align: center;
  line-height: 1;
  font-size: 20px;
  color: #292929;
  padding: 100px 0 30px;
}
.function-content li p.detail {
  text-align: center;
  line-height: 180%;
  font-size: 14px;
  color: #7f7f7f;
}
.function-content li i {
  display: block;
  width: 100px;
  height: 100px;
  position: absolute;
  left: 50%;
  margin-left: -50px;
  top: -50px;
}
.function-content li i.function-1 {
  background: url('~@/assets/function_1.png') no-repeat 50% 50%;
}
.function-content li i.function-2 {
  background: url('~@/assets/function_2.png') no-repeat 50% 50%;
}
.function-content li i.function-3 {
  background: url('~@/assets/function_3.png') no-repeat 50% 50%;
}
.function-content li i.function-4 {
  background: url('~@/assets/function_4.png') no-repeat 50% 50%;
}
.function-content li i.function-5 {
  background: url('~@/assets/function_5.png') no-repeat 50% 50%;
}
.function-content li i.function-6 {
  background: url('~@/assets/function_6.png') no-repeat 50% 50%;
}

.gc_ceng.gc_ceng_four {
    padding: 70px 0 0;
    background: #fff;
    background: url('~@/assets/products-bg.714f810.png')
}

.gc_ceng .ceng_thin {
    max-width: 1200px;
    width: 100%;
    margin: 0 auto;
    text-align: left;
}

.gc_ceng .ceng_thin .ceng_title {
    font-size: 32px;
    font-family: PingFangSC-Medium,PingFang SC;
    font-weight: 500;
    color: #333;
    line-height: 40px;
    margin: 0 0 20px;
    text-align: center;
}

.gc_ceng .ceng_thin .ceng_decro {
    font-size: 16px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #666;
    line-height: 15px;
    margin: 0 0 70px;
    text-align: center;
}

.gc_ceng.gc_ceng_four .ceng_box {
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-around;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
}

.gc_ceng.gc_ceng_four .ceng_box>div {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 180px;
    flex: 0 0 180px;
    margin: 0 0 40px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}

.gc_ceng.gc_ceng_four .ceng_box>div>div {
    width: 180px;
    height: 180px;
    margin: 0 0 40px;
    background: #fff;
    -webkit-box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    box-shadow: 0 8px 48px 0 rgb(223 226 236 / 60%);
    border-radius: 50%;
}

.gc_ceng.gc_ceng_four .ceng_box>div>p {
    text-align: center;
    font-size: 15px;
    font-family: PingFangSC-Regular,PingFang SC;
    font-weight: 400;
    color: #333;
    line-height: 34px;
}
.gc_ceng.gc_ceng_four .ceng_box>div>div>img {
    /* max-width: 100%; */
    max-height: 100%;
    position: relative;
    left: 50%;
    top: 50%;
    -webkit-transform: translate(-50%,-50%);
    transform: translate(-50%,-50%);
}

.title {
  /* max-width: 1200px;   */
  text-align: center;
  margin: 0 auto;
}

.practice {
  padding-bottom:60px;
}

.practice h1{
  padding: 50px 0 50px 0;
}

.practice img {
  padding: 50px 0 50px 0;
}

#solutiontext {
  color:whitesmoke;
  padding-bottom: 30px;
}

.solutionList {
  color: whitesmoke;
  display: flex;
  justify-content: space-around;
  background-color: #000413;
}

.solutionContent {
  display: flex;
  padding-top: 30px;
}

.solutionList h4 {
  margin: 0;
}

.leftList {
  width: 400px;
  text-align: left;
  margin-top: 40px;
}

.leftList p {
  font-size:26px;
}

.listItem {
  padding: 20px 100px 20px 100px;
  background-color: #000413;
}

.leftItem p{
  color: whitesmoke;
  text-align: left;
  padding: 2%;
}

.leftItem {
  display: flex;
  margin:5px;
  padding:3px;
  background: linear-gradient(to right,rgba(64, 224, 208, 1), rgba(64, 224, 208, 0));
}

.rightContent {
  /* background: url(../assets/solution3-1.97f0170.png); */
  width:780px;
  /* height: 300px; */
  margin: auto;
  text-align: left;
}

.rightContent p {
  color:whitesmoke;
  text-align:left;
}

#review2 {
  background-color:#f7fafe;
}

.system-content {
    text-align: center;
    width: 100%;
    position: relative;
    overflow: hidden;
    /* margin-bottom: 140px; */
    padding-top: 20px;
    padding-left:0;
    display: flex;
    justify-content: space-around;
}

.system-content li {
    display: inline-block;
    width: 108px;
    height: 178px;
    /* margin-left: 240px; */
}

.system-content li:first-child {
  margin-left: 0px;
}

/* .system-content li i.setup {
    background: url(../assets/system_1.png)no-repeat 50% 50%;
}

.system-content li i.maintain {
    background: url(../assets/system_2.png) no-repeat 50% 50%;
}
.system-content li i.handle {
    width: 118px;
    margin-left: -5px;
    background: url(../assets/sample.png) no-repeat 50% 50%;
} */

.system-content li p {
    vertical-align: bottom;
    font-size: 16px;
    color: #01010a;
    text-align: center;
    line-height: 1;
    padding-top: 54px;
}

/* ----------左右布局------------------------------- */

</style>>



// WEBPACK FOOTER //
// src/views/products/components/assetManagement.vue